import { getAppServerSettings } from "@advosys/component-app-server-client-js";
import { getClientId } from "../app-server";
import { AuthService } from "./auth-service";
const getAuthenticationEndpointAsync = async (tenantId) => {
    const result = await fetch(`https://${getAppServerSettings().baseUrl}/oidc/v1/tenants/${tenantId}/openid-connect-authority`);
    if (result.ok) {
        return await result.json();
    }
    throw Error("Error occurred while getting authentication endpoints.");
};
let authService;
export const initAuthServiceAsync = async (tenantId) => {
    localStorage.setItem("tenantId", tenantId);
    const endpoints = await getAuthenticationEndpointAsync(tenantId);
    const clientId = getClientId();
    authService = await AuthService.create(endpoints.authority, clientId);
};
export const getAuthService = () => {
    if (!authService) {
        throw new Error("AuthService not initialized. Call initAuthService first.");
    }
    return authService;
};
